import $ from 'jquery';

export default function printQuote() {
  $('.raq-print').on('click', () => {
    window.print();
  });
}
